import axios from "axios"
import React, { useState } from "react"
import "../App.css"
import { SERVER_URI } from "../utility/config"
import LoginRequest from "./LoginRequest"

function ContactPhoneNumberCreatedMessage(props) {
	window.setTimeout(function () {
		// Move to a new location
		props.handleClose()
	}, 1700)
	return (
		<div>
			<h2 className="message_title">Puhelinnumero asetettu</h2>
		</div>
	)
}

function SetContactPhoneNumber(props) {
	const [show, setShow] = useState(false)
	const [userData, setUserData] = useState({
		contactPhoneNumber: props.currentContactPhoneNumber,
	})
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")

	//Look at this closer

	const onChange = (e) => {
		setUserData({ ...userData, [e.target.name]: e.target.value })
	}

	// Submit
	const doSubmit = async (e) => {
		e.preventDefault()
		const dataToServer = userData
		try {
			await axios.put(`${SERVER_URI}/set_contact_phone_number/`, dataToServer, {
				headers: { Authorization: `Token ${userToken}` },
			})
			props.dispatch({
				type: "UPDATE_CONTACT_PHONE_NUMBER",
				data: { newNumber: dataToServer.contactPhoneNumber },
			})
			setShow(!show)
		} catch (e) {
			console.log("Error in setting contact phone number.", e)
		}
	}
	return (
		<div className="popUp_card">
			<div className="popup-box">
				<div className="box">
					<span className="close-icon" onClick={props.handleClose}>
						x
					</span>
					{!show && (
						<div>
							<h2 className="popUp_title">Aseta uusi puhelinnumero</h2>
							<form className="rejectionReason_form" onSubmit={(e) => doSubmit(e)}>
								<label className="label_add" htmlFor="rejectReason">
									Puhelinnumero:
								</label>
								<input
									id="rejectReason"
									name="contactPhoneNumber"
									onChange={onChange}
									value={userData.contactPhoneNumber}
									required></input>{" "}
								<br className="desktop-break" />
								<input type="submit" id="gradient_Button" value="Aseta puhelinnumero" />
							</form>
						</div>
					)}
					{show && <ContactPhoneNumberCreatedMessage handleClose={props.handleClose} />}
				</div>
			</div>
		</div>
	)
}

function ContactPhoneNumber(props) {
	props.stopListRefresh()
	const [isOpen, setIsOpen] = useState(false)
	//const [isloggedIn, setIsloggedIn] = useState(true);
	//let storage = window.localStorage;
	//let userToken = storage.getItem("admin_token")

	/* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

	const togglePopUp = async () => {
		setIsOpen(!isOpen)
	}

	return (
		<div className="configurations">
			{isOpen && <SetContactPhoneNumber dispatch={props.dispatch} currentContactPhoneNumber={props.contactPhoneNumber} handleClose={togglePopUp} />}
			<h3>Yhteydenottopuhelinnumero</h3>
			<div className="rides">
				{props.contactPhoneNumber === undefined ? (
					<LoginRequest />
				) : props.contactPhoneNumber.length === 0 ? (
					<h4>Puhelinnumeroa ei asetettu</h4>
				) : (
					<div className="customer_list">
						{props.contactPhoneNumber}
						<br />
					</div>
				)}
			</div>
			<button id="gradient_Button" onClick={togglePopUp}>
				Aseta puhelinnumero
			</button>
		</div>
	)
}

export default ContactPhoneNumber
